/* eslint-disable react/prop-types */
/* global FB */
import { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'

import AccountSelectionPage from '../AccountSelectionPage'
import { SignInAnimation } from '../../components/SignInAnimation'

import 'react-toastify/dist/ReactToastify.css'

import { ArrowRigth, Eye, GoogleColorIcon, LockClosed, LockClosedCampaignIcon, LockClosedOutlineCustom } from '../../assets/svgs/icons'

import {
  Login,
  OneSignalService,
  UserAccountsService,
  UserService,
} from '../../services/index'

import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

import Loading from '../../components/Loading'

import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { sendUserCreatedAnalyticsEvent } from '../../services/analytics-metrics.service'
import { notifyErrorCustom, notifySuccessCustom } from '../../utils/notify'
import DefaulterPage from '../DefaulterPage'
import { PhoneInput } from 'react-international-phone'
import 'react-international-phone/style.css'
import { IntlContext } from '../../contexts/IntlContext/IntlContext'
import { useGoogleAdsTracking, GOOGLE_ADS_EVENTS } from '../../utils/googleAdsTracking'
import { saveCampaignPromptFromSearch } from '../../utils/campaignPromptStorage'
import { BenefitsNotification } from '../../components/BenefitsNotification'
import { useGoogleLogin } from '@react-oauth/google'
import { LuMail } from 'react-icons/lu'
import { PiEyeClosed } from 'react-icons/pi'

const INVITE_STORAGE_KEY = 'inviteId'

function Register() {
  const { login } = useAuth()
  const navigation = useNavigate()
  const location = useLocation()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [phone, setPhone] = useState('')

  const [loading, setLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [registrationStep, setRegistrationStep] = useState('email')

  const [usersTologin, setUsersToLogin] = useState(false)

  const [bodyLoginUser, setBodyLoginUser] = useState(false)

  const [userDefaulter, setUserDefaulter] = useState([])

  const [guestUser, setGuestUser] = useState(false)
  const [showPass, setShowPass] = useState(false)
  const [confirmShowPass, setConfirmShowPass] = useState(false)
  const [benefitNotification, setBenefitNotification] = useState('')
  const { country } = useContext(IntlContext)
  const { getGoogleAdsParams } = useGoogleAdsTracking()
  const { t, i18n } = useTranslation()

  const defaultPhoneCountry = country === 'br' ? 'br' : 'us'

  const preservePremiumInParams = (baseParams) => {
    const isPremiumInStorage = localStorage.getItem('premium') === 'true'
    if (isPremiumInStorage) {
      return baseParams ? `${baseParams}&premium=true` : 'premium=true'
    }
    return baseParams || ''
  }

  const buildPostSignupRedirectPath = (googleAdsParams = '') => {
    const premiumParams = preservePremiumInParams(googleAdsParams)
    return premiumParams ? `/ChatSocket?${premiumParams}` : '/ChatSocket'
  }

  const googleRegister = useGoogleLogin({
    scope: 'openid profile email',
    onSuccess: async ({ access_token: accessToken }) => {
      if (!accessToken) {
        notifyErrorCustom('Não foi possível autenticar com o Google.')
        return
      }
      setButtonLoading(true)

      try {
        // First, retrieve the user's email from Google to verify existence before attempting register
        let googleEmail = null
        try {
          const resp = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          if (resp && resp.ok) {
            const info = await resp.json()
            googleEmail = info?.email || null
          }
        } catch (e) {
          console.warn('Failed to fetch google userinfo', e)
        }

        if (googleEmail) {
          try {
            const check = await UserService.getUserCheckEmailExists(googleEmail)
            if (check?.data?.exists === true) {
              notifyErrorCustom(t('fast_publishing_email_already_registered'))
              setButtonLoading(false)
              return
            }
          } catch (e) {
            console.warn('email existence check failed before google register', e)
            // proceed if check fails
          }
        }

        const googleLoginData = await Login.postAuthRegisterGoogle({
          credential: accessToken,
          idToken: accessToken,
          token: accessToken,
        })

        if (googleLoginData?.responseStatus !== 200) {
          throw new Error('Falha no login com Google')
        }

        // If backend signals the email/user already exists, abort registration flow
        const googleRaw = googleLoginData?.data || {}
        const googleInner = googleRaw?.data || {}
        const respMessage = googleRaw?.message || googleInner?.message || ''

        const alreadyRegisteredFlag =
          googleInner?.exists === true ||
          googleRaw?.exists === true ||
          googleInner?.alreadyRegistered === true ||
          googleRaw?.alreadyRegistered === true ||
          googleInner?.userAlreadyExists === true ||
          googleRaw?.userAlreadyExists === true ||
          (typeof respMessage === 'string' && /already|exists|registered/i.test(respMessage))

        if (alreadyRegisteredFlag) {
          notifyErrorCustom(t('fast_publishing_email_already_registered'))
          setButtonLoading(false)
          return
        }

        const googleAdsParams = getGoogleAdsParams(GOOGLE_ADS_EVENTS.USER_REGISTRATION, false)
        const redirectPath = buildPostSignupRedirectPath(googleAdsParams)

        const googleSession = googleLoginData.data?.data || googleLoginData.data

        try {
          // // Verify user does not already exist before calling login to avoid in-app redirect
          // const sessionEmail =
          //   googleSession?.user?.email || googleSession?.email || googleSession?.data?.email || googleSession?.userEmail || null

          // if (sessionEmail) {
          //   try {
          //     const checkExisting = await UserService.getUserCheckEmailExists(sessionEmail)
          //     if (checkExisting?.data?.exists === true) {
          //       notifyErrorCustom(t('fast_publishing_email_already_registered'))
          //       setButtonLoading(false)
          //       return
          //     }
          //   } catch (e) {
          //     // If the existence check fails, we don't block flow; continue to login
          //     console.warn('User existence check failed', e)
          //   }
          // }

          await login(googleSession, redirectPath)
          return
        } catch (err) {

          const googleSessionToken = googleSession?.token || googleSession?.access_token || googleSession?.accessToken
          window.localStorage.setItem('userData', JSON.stringify(googleSession))
          if (googleSessionToken) {
            window.localStorage.setItem('token', JSON.stringify(googleSessionToken))
          }
          navigation(redirectPath)
        }

      } catch (error) {
        console.error('error googleRegister', error)
        notifyErrorCustom('Não foi possível concluir o cadastro com Google.')
      } finally {
        setButtonLoading(false)
      }
    },
    onError: () => {
      notifyErrorCustom('Falha no cadastro com Google.')
    },
  })

  const initFacebookSDK = () => {
    window.fbAsyncInit = function () {
      FB.init({
        appId: '387543906967686',
        cookie: true,
        xfbml: true,
        version: 'v18.0',
      })

      FB.AppEvents.logPageView()
    }
    ; (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }

  useEffect(() => {
    initFacebookSDK()
  }, [])

  useEffect(() => {
    saveCampaignPromptFromSearch(location.search)
  }, [location.search])

  const handleShowPass = (param) => {
    if (param === 'pass') {
      setShowPass((current) => !current)
    }
    if (param === 'confirmPass') {
      setConfirmShowPass((current) => !current)
    }
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  }

  const handlePasswordChange = (event) => {
    setPassword(event.target.value)
  }

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value)
  }

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value)
  }

  const handleEditEmail = () => {
    setRegistrationStep('email')
  }

  const handleNavigateToSignIn = () => {
    const storedInviteId = window.localStorage.getItem(INVITE_STORAGE_KEY)
    const search = location.search || (storedInviteId ? `?inviteId=${storedInviteId}` : '')
    navigation(`/SignIn${search}`)
  }

  const checkFields = () => {
    if (email === '') {
      notifyErrorCustom(t('signin_error_email'))
      return false
    }

    if (password === '') {
      notifyErrorCustom(t('signin_error_password'))
      return false
    }

    if (password.length < 8) {
      notifyErrorCustom(t('signin_error_password_and_user'))
      return false
    }

    return true
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (registrationStep === 'email') {
      await handleContinueToDetails()
      return
    }

    await handleCreateAccount()
  }

  const handleContinueToDetails = async () => {
    if (email === '') {
      notifyErrorCustom(t('fast_publishing_email_enter_your_email_alert'))
      return
    } else if (!isValidEmail(email)) {
      notifyErrorCustom(t('fast_publishing_email_invalid_format'))
      return
    }

    setButtonLoading(true)
    const checkEmailExists = await UserService.getUserCheckEmailExists(email)

    if (checkEmailExists?.data?.exists === true) {
      notifyErrorCustom(t('fast_publishing_email_already_registered'))
      setButtonLoading(false)
      return
    }

    window.setTimeout(() => {
      setRegistrationStep('details')
      setButtonLoading(false)
    }, 450)
  }

  const isValidEmail = (email) => {
    // Expressão regular para validar e-mail
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    // Testa o e-mail recebido com o regex
    return emailRegex.test(email)
  }

  const handleCreateAccount = async () => {
    if (firstName === '') {
      notifyErrorCustom(t('fast_publishing_name_enter_your_fullname_alert'))
      setLoading(false)
      setButtonLoading(false)
      return
    }

    if (email === '') {
      notifyErrorCustom(t('fast_publishing_email_enter_your_email_alert'))
      setButtonLoading(false)
      return
    } else if (!isValidEmail(email)) {
      notifyErrorCustom(t('fast_publishing_email_invalid_format'))
      setLoading(false)
      setButtonLoading(false)
      return
    }

    setLoading(true)
    setButtonLoading(true)
    const checkEmailExists = await UserService.getUserCheckEmailExists(email)
    if (checkEmailExists?.data?.exists === true) {
      notifyErrorCustom(t('fast_publishing_email_already_registered'))
      setLoading(false)
      setButtonLoading(false)
      return
      // response = checkEmailExists?.data?.exists
    }

    if (phone === '') {
      notifyErrorCustom(t('fast_publishing_phone_enter_your_phone_alert'))
      setLoading(false)
      setButtonLoading(false)
      return
    }

    if (password === '' || confirmPassword === '') {
      notifyErrorCustom(t('fast_publishing_pass_enter_your_password_alert'))
      setLoading(false)
      setButtonLoading(false)
      return
    }
    if (!passwordHasMinimumLength) {
      notifyErrorCustom('A senha precisa ter no mínimo 8 caracteres.')
      setLoading(false)
      setButtonLoading(false)
      return
    }

    if (!passwordHasLetter || !passwordHasNumber) {
      notifyErrorCustom('A senha precisa conter letras e números.')
      setLoading(false)
      setButtonLoading(false)
      return
    }

    if (!passwordHasSpecial) {
      notifyErrorCustom('A senha precisa conter pelo menos 1 caractere especial.')
      setLoading(false)
      setButtonLoading(false)
      return
    }

    if (!passwordsMatch) {
      notifyErrorCustom(t('fast_publishing_pass_confirmation_password_alert'))
      setLoading(false)
      setButtonLoading(false)
      return
    }

    const fullName = firstName.trim()
    const wordsArray = fullName.split(/\s+/)

    const [firstNameToSend, ...rest] = wordsArray
    let bodyUser = {
      name: firstNameToSend,
      surname: rest.toString().replace(/,/g, ' '),
      phone: phone,
      email: email,
      password: password,
      knowledgeChannelId: 0,
    }

    const storedInviteId = window.localStorage.getItem(INVITE_STORAGE_KEY)
    if (storedInviteId) {
      bodyUser.inviteId = storedInviteId
    }

    const UserReturn = await UserService.postUser(bodyUser)
    // console.log('userReturr', UserReturn)
    if (
      UserReturn?.responseStatus != 200 &&
      UserReturn?.responseStatus != 204
    ) {

      notifyErrorCustom(t('fast_publishing_error_register_user'))

      setLoading(false)
      setButtonLoading(false)
      return
    } else {
      notifySuccessCustom(t('fast_publishing_user_created_successfully'))

      if (storedInviteId) {
        setBenefitNotification('Convite aplicado com sucesso no cadastro.')
        window.localStorage.removeItem(INVITE_STORAGE_KEY)
      }


      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({
      //   event: "registration_information_completed",
      //   user_email: email,
      // });

      let bodyUserAccounts = {
        userId: UserReturn?.data?.uuid,
        userAccountTypeId: 0,
        cpf: '',
        cnpj: '',
        fantasyName: '',
        corporateName: '',
        cep: '',
        logradouro: '',
        number: '',
        complement: '',
        city: '',
        lastLogin: new Date(),
        lang: i18n.resolvedLanguage ?? 'ptBR',
      }

      let userAccountsRegister =
        await UserAccountsService.postUserAccountsRegister(bodyUserAccounts)

      if (userAccountsRegister?.responseStatus != 200) {
        notifyErrorCustom(t('fast_publishing_error_register_user'))
        setLoading(false)
        setButtonLoading(false)
        return
      } else {
        const bodyOnesignal = {
          userCode: UserReturn?.data?.uuid
        }


        await sendUserCreatedAnalyticsEvent()

        const googleAdsParams = getGoogleAdsParams(GOOGLE_ADS_EVENTS.USER_REGISTRATION, false)
        await handleLogin(googleAdsParams)
        await OneSignalService.postUserOneSignal(bodyOnesignal)
        // console.log('oneSignalRegister', oneSignalRegister)

        // const googleAdsParams = UserReturn?.data?.googleAdsParams || 'event=200'
        // const redirectPath = `/PlanCheckout?${googleAdsParams}`

        // navigation(redirectPath)
        setLoading(false)
      }

      // const dataEvent = {
      //   event: 'user_signed_up',
      //   eventData: {},
      // }
      // await registerEvent(dataEvent)

      setButtonLoading(false)
    }
  }

  const handleLogin = async (googleAdsParams = '') => {
    if (!checkFields()) {
      return setLoading(false)
    }

    let body = {
      email: email,
      password: password,
    }
    const checkUsers = await Login.postCheckUser(body)

    if (
      checkUsers?.data?.isDefaulter &&
      checkUsers.data.userBusiness.length <= 0
    ) {
      const userDefaulter = {
        userDefaulter: checkUsers.data.user,
        guestUser: false,
      }
      setUserDefaulter(userDefaulter)
      setGuestUser(false)
      setLoading(false)

      return
    }

    if (
      ((checkUsers?.data?.user != null &&
        checkUsers?.data?.userBusiness?.length > 0) ||
        checkUsers?.data?.userBusiness?.length > 1) &&
      checkUsers.data.passwordOk
    ) {
      await setUsersToLogin(checkUsers)
      await setBodyLoginUser(body)
    } else if (
      !checkUsers?.data?.user &&
      checkUsers?.data?.userBusiness?.length == 1 &&
      checkUsers?.data?.passwordOk
    ) {
      const uuid = checkUsers.data.userBusiness[0].uuid
      const bodyToLogin = { ...body, uuid }
      let loginGuestData = await Login.postGuestComparePassword(bodyToLogin)
      if (loginGuestData?.responseStatus === 200) {
        const guestUserId = uuid
        const loginDataRet = { ...loginGuestData.data, guestUserId }
        setLoading(false)

        const redirectPath = buildPostSignupRedirectPath(googleAdsParams)
        login(loginDataRet, redirectPath)

        let userAccount = checkUsers.data.user.UserAccount[0]

        if (userAccount) {
          userAccount.lastLogin = new Date()

          delete userAccount.uuid
          delete userAccount.createdAt
          delete userAccount.updatedAt
          delete userAccount.deletedAt
          delete userAccount.freePlanChose
          delete userAccount.state
          delete userAccount.photoName
          delete userAccount.photoUrl

          await UserAccountsService.putUserAccountsByLogin(userAccount)
        }
      }
    } else if (!checkUsers?.data?.passwordOk) {
      notifyErrorCustom(t('signin_error_password_and_user'))
      setLoading(false)
      return
    } else {
      let loginData = await Login.postAuth(body)

      if (loginData?.responseStatus === 200) {
        setLoading(false)
        const loginDataRet = { ...loginData.data }
        const redirectPath = buildPostSignupRedirectPath(googleAdsParams)
        await login(loginDataRet, redirectPath)
        let userAccount = checkUsers.data.user.UserAccount[0]

        if (userAccount) {
          userAccount.lastLogin = new Date()

          delete userAccount.uuid
          delete userAccount.createdAt
          delete userAccount.updatedAt
          delete userAccount.deletedAt
          delete userAccount.freePlanChose
          delete userAccount.state
          delete userAccount.photoName
          delete userAccount.photoUrl

          await UserAccountsService.putUserAccountsByLogin(userAccount)
        }
      }

      if (loginData?.response?.status === 401) {
        notifyErrorCustom(t('signin_error_password_and_user'))
        setLoading(false)
        return
      }
    }

    setLoading(false)
  }

  const isDetailsStep = registrationStep === 'details'
  const isContinueLoading = buttonLoading || loading
  const passwordHasMinimumLength = password.length >= 8
  const passwordHasNumber = (() => {
    if (!password) return false
    const m = password.match(/\d+/)
    return m !== null && Number.isFinite(Number(m[0]))
  })()
  const passwordHasLetter = /[A-Za-z]/.test(password)
  const passwordHasSpecial = /[^A-Za-z0-9]/.test(password)
  const passwordsMatch =
    password.length > 0 && confirmPassword.length > 0 && password === confirmPassword

  const passwordRules = [
    !passwordHasMinimumLength && 'Mínimo de 8 caracteres',
    !(passwordHasLetter && passwordHasNumber) && 'Contém letras e números',
    !passwordHasSpecial && 'Pelo menos 1 caractere especial',
    !passwordsMatch && 'As senhas precisam coincidir',
  ].filter(Boolean)

  const showPasswordRules = isDetailsStep
  const showConfirmPasswordError =
    confirmPassword.length > 0 && password.length > 0 && !passwordsMatch

  return (
    <motion.div
      // key={expanded}
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{ width: '100%', height: '100%', overflow: 'auto' }}
    >
      <>
        <BenefitsNotification
          active={Boolean(benefitNotification)}
          message={benefitNotification}
        />
        {userDefaulter.userDefaulter ? (
          <DefaulterPage userDefaulter={userDefaulter} guestUser={guestUser} />
        ) : (
          <div className={!usersTologin ? styles.page : ''}>
            <Loading enable={loading} />

            {usersTologin && (
              <AccountSelectionPage
                usersTologin={usersTologin}
                bodyLoginUser={bodyLoginUser}
              />
            )}
            {!usersTologin && (
              <div className={styles.sign_in_field}>
                <div className={styles.sign_box}>
                  <SignInAnimation />
                </div>

                <div className={styles.sign_box_login}>
                  <div className={styles.container_content}>
                    <div className={styles.sign_in_form_field}>
                      <div className={styles.register_title_block}>
                        <p className={styles.sign_in_form_field_login_title}>
                          {t('register_sign_up')}
                        </p>
                        <p className={styles.sign_in_form_field_login_subtitle}>
                          {t('register_enter_data')}
                        </p>
                      </div>

                      <button
                        className={styles.google_login_button}
                        type="button"
                        onClick={() => googleRegister()}
                      >
                        <GoogleColorIcon />
                        <span>Continuar com Google</span>
                      </button>

                      <div className={styles.login_divider}>
                        <span>ou</span>
                      </div>

                      <form
                        className={styles.input_field}
                        onSubmit={handleSubmit}
                      >
                        {!isDetailsStep ? (
                          <>
                            <div className={styles.box_input_form}>
                              <span>E-mail</span>
                              <div className={styles.email_input_shell}>
                                <span className={styles.email_input_icon} aria-hidden="true">
                                  <LuMail size={24} color='rgba(166, 166, 178, 1)' />
                                </span>
                                <input
                                  className={styles.inputs}
                                  type="email"
                                  placeholder="seu@email.com"
                                  value={email}
                                  onChange={handleEmailChange}
                                  autoComplete="email"
                                />
                              </div>
                            </div>

                            <div className={`${styles.box_button_submit} ${styles.box_button_submit_margin}`}>
                              <div className={styles.box_button_submit_disable}>
                                <button
                                  className={isContinueLoading ? styles.button_submit_disable : styles.button_submit}
                                  type="submit"
                                  disabled={isContinueLoading}
                                  data-loading={isContinueLoading ? 'true' : 'false'}
                                >
                                  {isContinueLoading ? (
                                    <span className={styles.button_loading_content}>
                                      <span className={styles.button_loading_spinner} />
                                      <span>Carregando...</span>
                                    </span>
                                  ) : (
                                    <>
                                      <span>Continuar</span>
                                      <ArrowRigth />
                                      {/* <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.6849 6.58365C10.8044 2.88296 6.30543 0.500214 1.25001 0.5C1.05109 0.499992 0.860331 0.579005 0.719681 0.719659C0.579032 0.860312 0.50001 1.05108 0.50001 1.25C0.50001 6.30564 2.88276 10.805 6.58356 13.6859C6.52853 14.0329 6.50001 14.3883 6.50001 14.75C6.50001 18.4779 9.52211 21.5 13.25 21.5C13.6642 21.5 14 21.1642 14 20.75V16.6185C14.0093 16.6118 14.0184 16.6049 14.0274 16.5978C14.9794 15.8429 15.842 14.9803 16.5969 14.0282C16.6042 14.019 16.6113 14.0096 16.6182 14H20.75C21.1642 14 21.5 13.6642 21.5 13.25C21.5 9.52208 18.4779 6.5 14.75 6.5C14.388 6.5 14.0323 6.52856 13.6849 6.58365ZM8.99999 10.25C7.75739 10.25 6.74999 9.24264 6.74999 8C6.74999 6.75736 7.75739 5.75 8.99999 5.75C10.2426 5.75 11.25 6.75736 11.25 8C11.25 9.24264 10.2426 10.25 8.99999 10.25Z" fill="white" />
                                        <path d="M17.7396 16.2418C17.4076 15.9942 17.3393 15.5242 17.587 15.1922C17.8346 14.8602 18.3045 14.7918 18.6365 15.0395C19.9178 15.9954 20.75 17.5256 20.75 19.2499C20.75 19.5255 20.7287 19.7966 20.6875 20.0615C20.6374 20.3842 20.3843 20.6373 20.0616 20.6875C19.7966 20.7286 19.5256 20.7499 19.25 20.7499C17.5257 20.7499 15.9955 19.9178 15.0396 18.6365C14.7919 18.3045 14.8603 17.8345 15.1923 17.5869C15.5243 17.3392 15.9942 17.4075 16.2419 17.7396C16.9268 18.6577 18.0192 19.2499 19.25 19.2499C19.25 18.0191 18.6579 16.9268 17.7396 16.2418Z" fill="white" />
                                      </svg> */}
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className={styles.box_input_form}>
                              <span>E-mail</span>
                              <div className={styles.email_review_shell}>
                                <div className={styles.email_input_shell}>
                                  <span className={styles.email_input_icon} aria-hidden="true">
                                    <LuMail size={24} color='rgba(166, 166, 178, 1)' />
                                  </span>
                                  <input
                                    className={styles.inputs}
                                    type="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    autoComplete="email"
                                    readOnly
                                  />
                                  <button
                                    type="button"
                                    className={styles.email_edit_button}
                                    onClick={handleEditEmail}
                                    aria-label="Editar email"
                                  >
                                    Editar
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div className={styles.two_inputs_row}>
                              <div className={`${styles.box_input_form} ${styles.input_half}`}>
                                <span>{t('register_full_name')}</span>
                                <div className={styles.field_input_shell}>
                                  <input
                                    className={styles.inputs}
                                    type="text"
                                    placeholder={t('register_full_name_placeholder')}
                                    value={firstName}
                                    onChange={handleFirstNameChange}
                                    autoComplete="name"
                                  />
                                </div>
                              </div>

                              <div className={`${styles.box_input_form} ${styles.input_half}`}>
                                <span>{t('register_phone')}</span>
                                <div className={`${styles.field_input_shell} ${styles.phone_input_shell}`}>
                                  <PhoneInput
                                    key={defaultPhoneCountry}
                                    id="phoneinput"
                                    defaultCountry={defaultPhoneCountry}
                                    value={phone}
                                    placeholder={t('register_phone_placeholder')}
                                    onChange={setPhone}
                                    countrySelectorStyleProps={{
                                      style: { height: '100%' },
                                      buttonStyle: {
                                        height: '100%',
                                        border: 'none',
                                        borderRight: '1px solid rgba(25, 0, 39, 0.12)',
                                        borderRadius: 0,
                                        background: 'transparent',
                                        padding: '0 10px 0 12px',
                                        margin: 0,
                                      },
                                    }}
                                    inputStyle={{
                                      height: '100%',
                                      border: 'none',
                                      borderRadius: 0,
                                      background: 'transparent',
                                      padding: '0 16px',
                                      fontSize: '14px',
                                      color: '#150624',
                                      margin: 0,
                                      boxShadow: 'none',
                                    }}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className={styles.two_inputs_row}>
                              <div className={`${styles.box_input_form} ${styles.input_half}`}>
                                <span>{t('register_password')}</span>
                                <div className={styles.password_input_shell}>
                                  <span className={styles.input_prefix_icon} aria-hidden="true">
                                    <LockClosedOutlineCustom color="#9DA1B2" />
                                  </span>
                                  <input
                                    className={styles.inputs}
                                    type={showPass ? 'text' : 'password'}
                                    placeholder={t('register_password_placeholder')}
                                    value={password}
                                    onChange={handlePasswordChange}
                                    autoComplete="new-password"
                                  />
                                  <button
                                    type="button"
                                    onClick={() => handleShowPass('pass')}
                                    className={styles.password_toggle_button}
                                    aria-label={showPass ? 'Ocultar senha' : 'Mostrar senha'}
                                  >
                                    {showPass ? <PiEyeClosed /> : <Eye />}
                                  </button>
                                </div>
                              </div>

                              <div className={`${styles.box_input_form} ${styles.input_half}`}>

                                <span>{t('register_confirm_password')}</span>
                                <div className={styles.password_input_shell}>
                                  <span className={styles.input_prefix_icon} aria-hidden="true">
                                    <LockClosedOutlineCustom color="#9DA1B2" />
                                  </span>
                                  <input
                                    className={styles.inputs}
                                    type={confirmShowPass ? 'text' : 'password'}
                                    placeholder={t('register_confirm_password_placeholder')}
                                    value={confirmPassword}
                                    onChange={handleConfirmPasswordChange}
                                    autoComplete="new-password"
                                  />
                                  <button
                                    type="button"
                                    onClick={() => handleShowPass('confirmPass')}
                                    className={styles.password_toggle_button}
                                    aria-label={confirmShowPass ? 'Ocultar confirmação de senha' : 'Mostrar confirmação de senha'}
                                  >
                                    {confirmShowPass ? <PiEyeClosed /> : <Eye />}
                                  </button>
                                </div>
                              </div>
                            </div>

                            {(showPasswordRules || showConfirmPasswordError) && (
                              <div className={styles.password_validation_row}>
                                {showPasswordRules && (
                                  <div className={styles.password_rules}>
                                    <strong className={styles.password_rules_title}>
                                      A senha precisa conter:
                                    </strong>
                                    <ul className={styles.password_rules_list}>
                                      {passwordRules.map((rule) => (
                                        <li key={rule}>{rule}</li>
                                      ))}
                                    </ul>
                                  </div>
                                )}

                                {showConfirmPasswordError && (
                                  <p className={styles.input_error_message}>
                                    As senhas precisam coincidir.
                                  </p>
                                )}
                              </div>
                            )}

                            <div className={styles.box_button_submit}>
                              <div className={styles.box_button_submit_disable}>
                                <button
                                  className={isContinueLoading ? styles.button_submit_disable : styles.button_submit}
                                  type="submit"
                                  disabled={isContinueLoading}
                                  data-loading={isContinueLoading ? 'true' : 'false'}
                                >
                                  {isContinueLoading ? (
                                    <span className={styles.button_loading_content}>
                                      <span className={styles.button_loading_spinner} />
                                      <span>Carregando...</span>
                                    </span>
                                  ) : (
                                    <>
                                      <span>Continuar</span>
                                      <ArrowRigth size={20} />
                                      {/* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 9H15" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M10 4.5L15 9L10 13.5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                      </svg> */}
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                        <div className={`${styles.sign_box_footer} `}>
                          <p
                            style={{
                              margin: '0px'

                            }}
                          >
                            {t('register_have_an_account')}
                          </p>
                          <button
                            type="button"
                            onClick={handleNavigateToSignIn}
                            className={styles.sign_in_link}
                          >
                            {t('register_login')}
                          </button>

                        </div>
                      </form>



                    </div>
                    <div className={styles.register_footer_note}>
                      <p className={styles.register_footer_terms}>
                        Ao continuar, você concorda com nossos{' '}
                        <a
                          href="https://xama.ai/termos-de-uso"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Termos de Uso
                        </a>{' '}
                        e{' '}
                        <a
                          href="https://xama.ai/politica-de-privacidade"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Política de Privacidade
                        </a>
                      </p>

                      <div className={`${styles.single_divider2}`}>
                        <span />
                      </div>

                      <div className={styles.register_footer_security}>
                        <LockClosedCampaignIcon width={18} height={18} color="#9DA1B2" />
                        <span>Seus dados estão protegidos com segurança</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            )}
          </div>
        )}
      </>
    </motion.div>
  )
}

export default Register
